<script lang="ts">
    import { appManager } from "../AppManagerStore";
    import { _ } from "svelte-i18n";

    const demoLink: string =
        "https://www.anyways.eu/app/routeplanner/47cd4ad9-08d9-48b6-8849-c8d9c71e03ad#map=16.03/4.83258/50.98534&route=car.fast,Marten%20Lemmensstraat%2049%2C%203200%20Aarschot%2C%20Belgium/4.82831/50.98886,Diestsestraat%2035%2C%203200%20Aarschot%2C%20Belgium/4.83707/50.98206";
</script>

<section id="what" class="py-6 py-lg-8 bg-white">
    <div class="container">
        <div class="row justify-content-center">
            <div class="col-12 col-md-6 col-lg-5 mb-6 mb-md-0">
                <span class="badge rounded-pill bg-primary-soft mb-3">
                    <span class="h6 text-uppercase"
                        >{$_("communicate.what.tag")}</span>
                </span>

                <h2>
                    {$_("communicate.what.title1")} <br />
                    <span class="text-primary"
                        >{$_("communicate.what.title2")}</span>
                </h2>
                <p class="fs-lg text-gray-700 mb-6">
                    {$_("communicate.what.content1")}
                </p>
                <p class="fs-lg text-gray-700 mb-6">
                    {$_("communicate.what.content2")}
                </p>

                <div class="row">
                    <div class="col-12 col-lg-6">
                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle bg-primary-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p class="text-primary">
                                {$_("communicate.media.check1")}
                            </p>
                        </div>
                        <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle bg-primary-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p class="text-primary mb-lg-0">
                                {$_("communicate.media.check2")}
                            </p>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6">
                        <div class="d-flex">
                            <span
                                class="badge badge-rounded-circle bg-primary-soft mt-1 me-4">
                                <i class="fe fe-check" />
                            </span>
                            <p class="text-primary">
                                {$_("communicate.media.check3")}
                            </p>
                        </div>

                        <!-- <div class="d-flex">
                            <div
                                class="badge badge-rounded-circle bg-primary-soft me-1 me-4">
                                <i class="fe fe-check" />
                            </div>

                            <p class="text-primary mb-0">{$_("communicate.media.check4")}</p>
                        </div> -->
                    </div>
                </div>
                <!-- <a href="#faqs" class="btn btn-primary me-1 mt-7 lift">
                    {$_("communicate.media.get")} <i class="fe fe-arrow-right ms-3" />
                </a> -->
            </div>
            <div class="col-12 col-md-6 d-md-none  ">
                <div class="row">
                    <div class="col-12">
                        <div class="bg-demo p-4 rounded">
                            <figure class="text-white m-0">
                                <img
                                    class="img-fluid rounded"
                                    src="{$appManager.PublicUrl}img/screenshots/desktop/reroute/reroute-mechelen-1.png"
                                    alt="Example screenshot." />
                                <figcaption>
                                    {$_("communicate.what.example.part1")}<a href={demoLink}
                                        >{$_("communicate.what.example.part2")}</a
                                    >{$_("communicate.what.example.part3")}
                                </figcaption>
                            </figure>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-12 col-md-6 d-none d-md-block bg-demo p-4 rounded">
                <iframe
                    class="position-relative demo-widget img-fluid rounded shadow-lg"
                    title="Mechelen ReRoute"
                    src={demoLink} />
                <!-- <div class="col-6">
                        <img
                            src="{$appManager.PublicUrl}img/communicate/gent-small.jpg"
                            alt="..."
                            class="img-fluid mb-4 rounded" />
                        <img
                        src="{$appManager.PublicUrl}img/communicate/screenshot-izegem.png"
                            alt="..."
                            class="img-fluid mb-4 rounded" />
                    </div>
                    <div class="col-6 mt-8 me-n5">
                        <img
                        src="{$appManager.PublicUrl}img/communicate/goodmove-small.jpg"
                            alt="..."
                            class="img-fluid rounded" />
                    </div> -->
            </div>
        </div>
    </div>
</section>

<style>
    figure {
        margin-left: auto !important;
        margin-right: auto !important;
        text-align: center;
        font-size: 0.9375rem;
    }
    .demo-widget {
        height: calc(100% * (1 / 0.6));
        width: calc(100% * (1 / 0.6));
        zoom: 0.6;
        transform: scale(0.6);
        transform-origin: 0 0;
        -moz-transform: scale(0.6);
        -moz-transform-origin: 0 0;
        -o-transform: scale(0.6);
        -o-transform-origin: 0 0;
        -webkit-transform: scale(0.6);
        -webkit-transform-origin: 0 0;
        max-width: unset;
    }

    .bg-demo {
        background-color: #1b2a4e;
    }

    @media (min-width: 768px) {
    }

    @media (min-width: 992px) {
    }

    @media (min-width: 1200px) {
    }
</style>
